import { Components, Theme } from "@mui/material/styles";

export const MuiDivider: Components<Theme>["MuiDivider"] = {
    styleOverrides: {
        root: {
            borderColor: "var(--mui-palette-gray-100)",
            "&::before, &::after": {
                borderColor: "inherit",
            },
        },
    },
};
